import { useUnit } from 'effector-react'
import { useEffect, useMemo } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { useSetFromComeLocation } from '~/shared/effector/previousLocation'
import { $modifiedUrl, setPlaybackParams } from '../model'
import { usePlayerDimensions } from './usePlayerDimensions'

export function usePlaybackUrlAdParams(
  url: string,
  playerContainer: HTMLDivElement | null
): string {
  const dimensions = usePlayerDimensions(url, playerContainer)

  const setUrl = useUnit(setPlaybackParams)
  const modifiedUrl = useUnit($modifiedUrl)

  // sessionId using in google pal analytics
  // it must be constant when open the player and when navigating via player
  const sessionId = useMemo(() => uuidv4(), [])

  // update previous location, where user was prior to player
  useSetFromComeLocation()

  useEffect(() => {
    setUrl({ url, sessionId, dimensions })
    return () => void setUrl({ url: '', sessionId, dimensions })
  }, [url, sessionId, setUrl, dimensions])

  return modifiedUrl
}
